import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { customerApi as api } from 'api/customer';

function CancelShipmentModal({
    getOrders,
    getSubscription,
    open,
    selectedChargeID,
    selectedShipmentID,
    setNotification,
    setOpen,
}) {
    const cancelShipment = async () => {
        const res = await api.cancelShipment(selectedChargeID, selectedShipmentID);
        if (!res.status) {
            setNotification({ text: `Unable to cancel shipment: ${res.msg}`, level: 'error' });
            return;
        }

        setNotification({ text: 'Shipment cancelled', level: 'success' });
        setOpen(false);
        getSubscription();
        getOrders();
    };

    return (
        <Dialog
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Cancel Shipment</DialogTitle>
            <DialogContent>Confirm cancel for shipment. No refunds will be issued.</DialogContent>
            <DialogActions>
                <Button onClick={cancelShipment}>Cancel Shipment</Button>
                <Button
                    onClick={() => {
                        setOpen(false);
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { CancelShipmentModal };
